import { s as r } from "../../../Table.module-Bb7fJIr8.js";
import { c as s } from "../../../index-2QXL0WYc.js";
import { useTable as a } from "./useTable.js";
const b = ({
  columnKey: i
}) => {
  var t;
  const e = (t = a()) == null ? void 0 : t.getColumnByKey(i);
  if (e)
    return {
      className: s({
        [r[`cell--${e == null ? void 0 : e.align}`]]: e == null ? void 0 : e.align,
        [r.divider]: e == null ? void 0 : e.divider,
        [r["cell--number"]]: (e == null ? void 0 : e.format) === "number",
        [r["cell--currency"]]: (e == null ? void 0 : e.format) === "currency"
      }),
      style: {
        width: e == null ? void 0 : e.width,
        minWidth: e == null ? void 0 : e.width
      }
    };
};
export {
  b as useIDSTableColumnStyles
};
